(() => {
  const TARGET_PATH = '/products/exfoliating-washcloth';
  const TARGET_PLAN_ID = '692647461172';
  const TARGET_PLAN_TEXT = 'Delivery every 90 days';
  const INITIAL_LOCK_DURATION = 5000;

  if (window.location.pathname.replace(/\/$/, '') !== TARGET_PATH) return;

  let initializationComplete = false;
  let userChangedPlan = false;
  let changeDispatched = false;

  const getSubscriptionSelects = () => {
    return Array.from(
      document.querySelectorAll(
        '.subscribe_purchase select.js_day_change'
      )
    );
  };

  const setNinetyDays = () => {
    if (userChangedPlan) return;

    const selects = getSubscriptionSelects();

    selects.forEach((select) => {
      const targetOption = Array.from(select.options).find((option) => {
        return (
          option.value === TARGET_PLAN_ID ||
          option.textContent.trim() === TARGET_PLAN_TEXT
        );
      });

      if (!targetOption) return;

      Array.from(select.options).forEach((option) => {
        const isTarget = option === targetOption;

        option.selected = isTarget;

        if (isTarget) {
          option.setAttribute('selected', 'selected');
        } else {
          option.removeAttribute('selected');
        }
      });

      select.value = targetOption.value;
      select.selectedIndex = Array.from(select.options).indexOf(targetOption);

      if (!changeDispatched) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    changeDispatched = true;
  };

  const handleUserChange = (event) => {
    if (!initializationComplete) return;

    const select = event.target.closest(
      '.subscribe_purchase select.js_day_change'
    );

    if (!select) return;

    userChangedPlan = true;
  };

  document.addEventListener('change', handleUserChange, true);

  const observer = new MutationObserver(() => {
    if (!initializationComplete && !userChangedPlan) {
      setNinetyDays();
    }
  });

  const initialize = () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setNinetyDays();

    const interval = window.setInterval(() => {
      setNinetyDays();
    }, 150);

    window.setTimeout(() => {
      window.clearInterval(interval);
      observer.disconnect();

      setNinetyDays();

      initializationComplete = true;
    }, INITIAL_LOCK_DURATION);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();